import { Field } from "formik";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "../select/Select";

const Recipients = ({
  count,
  type,
  email,
  handleChange,
}: {
  count: number;
  email?: string;
  type: IEmailTypes;
  handleChange: (event: { target: { name: string; value: any } }) => void;
}) => {
  switch (type) {
    case "fmuretssagsproeve":
      return (
        <Field
          component={Select}
          as="select"
          name="additionalRecipients"
          onValueChange={(value: string) => {
            handleChange({ target: { name: "additionalRecipients", value } });
          }}
          defaultValue="kandidat"
        >
          <SelectTrigger
            aria-label="Afsender"
            placeholder="Vælg afsender..."
            className="c-form-badge form-select--email"
          />
          <SelectContent>
            <SelectItem value="kandidat" key="kandidat">
              Kandidat
            </SelectItem>
            <SelectItem value="censor" key="censor">
              Censor
            </SelectItem>
            <SelectItem value="retten" key="retten">
              Retten
            </SelectItem>
          </SelectContent>
        </Field>
      );
    default:
      if (email) {
        return (
          <span className="c-form-badge c-form-badge-primary">{email}</span>
        );
      }
      return (
        <span className="c-form-badge c-form-badge-primary">
          {count} modtager{count === 1 ? "" : "e"}
        </span>
      );
  }
};
export default Recipients;
